export default __webpack_public_path__ + "static/media/cover-image.1751b1a1.png";